'use client'

import { useEffect } from 'react'

import { SEGMENT_EVENTS } from '@/configs/dataTrackingEvent'
import useHasAppearedInViewport from '@/hooks/useHasAppearedInViewport'
import { ResolvedRewardsCampaign } from '@/services/coin/rewardsCampaign'
import { trackSegmentEvent } from '@/services/dataTracking'

import { useCoinContext } from '../../_contexts/CoinContext'
import styles from './index.module.css'

interface RewardsCampaignCardProps {
  campaign: ResolvedRewardsCampaign
  locale: string
}

export default function RewardsCampaignCard({ campaign, locale }: RewardsCampaignCardProps) {
  const { coin } = useCoinContext()
  const { ref, hasAppearedInViewport } = useHasAppearedInViewport()

  useEffect(() => {
    if (hasAppearedInViewport) {
      trackSegmentEvent(SEGMENT_EVENTS.WebPriceCampaignBannerViewed, {
        campaign_id: campaign.campaign_code,
        coin: coin.symbol,
        page_path: window.location.pathname,
        locale,
      })
    }
  }, [hasAppearedInViewport])

  const handleCtaClick = () => {
    trackSegmentEvent(SEGMENT_EVENTS.WebPriceCampaignBannerClicked, {
      campaign_id: campaign.campaign_code,
      coin: coin.symbol,
      page_path: window.location.pathname,
      locale,
      destination_url: campaign.detail_page_url ?? '',
    })
  }

  return (
    <div ref={ref} className={styles.card}>
      <div className={styles.imageContainer}>
        {campaign.icon_url && <img src={campaign.icon_url} alt="" className={styles.image} />}
        <div className={styles.shadow} />
      </div>
      <div className={styles.content}>
        {campaign.header_text && <p className={styles.title}>{campaign.header_text}</p>}
        {campaign.subtext_text && <p className={styles.description}>{campaign.subtext_text}</p>}
        <a
          href={campaign.detail_page_url ?? undefined}
          className={styles.cta}
          onClick={handleCtaClick}
          target="_blank"
          rel="noopener noreferrer"
        >
          {campaign.cta_text && <p>{campaign.cta_text}</p>}
        </a>
      </div>
    </div>
  )
}
